import React, { ReactElement, useEffect, useRef } from 'react';
import { strings } from 'src/localization';
import * as css from './ROHistoryCard.module.scss';
import { ROHistory } from 'src/models/ROHistory/ROHistory';
// import { Link } from '@framework-controls/core';
import ROHistoryCardPanel from 'src/components/ROHistoryCard/ROHistoryCardPanel/containers/ROHistoryCardPanel';
import { random } from 'lodash';
import { CustMode } from 'src/enums';

export interface IProps {
    roHistory: ROHistory[];
    custMode: CustMode,
    theme: string,
    locale: string,
}

const ROHistoryCard = (props: IProps) => {
    const roHistoryRef = useRef<HTMLDivElement>(null);

    let roHistoryCardPanels: ReactElement[] | null = null;
    if (props.roHistory && props.roHistory.length > 0) {
        let opsTotal = 0;
        const sumOps = function (a, b) {
            return a + b;
        };
        props.roHistory.forEach(function (histRO) {
            opsTotal = sumOps(opsTotal, histRO.detail.length);
        });
        roHistoryCardPanels = props.roHistory.map(histRo => {
            const opDescs = histRo.detail.map(op => <ROHistoryCardPanel
                id={histRo.RO}
                opCode={op.opCode}
                scrollList={opsTotal > 3}
                key={histRo.RO + op.opCode}
            />);

            return <div key={histRo.RO + random}>{opDescs}</div>;
        });
    }

    let summaryTitleCSS = css.summaryTitle;
    if (props.theme === 'buick') {
        summaryTitleCSS = css.summaryTitleBuick;
    }
    if (props.theme === 'dodge') {
        summaryTitleCSS = css.summaryTitleDodge;
    }
    let cardMsgCSS = '';
    if (props.theme==='bmw') {
        cardMsgCSS = css.cardMsgBMW;
    }
    let historyMsg = strings.ROHistoryMsg.substring(0, 48);
    if (props.locale === 'fr-CA') {
        historyMsg = strings.ROHistoryMsg.substring(0, 66);
    }

    let roHistoryCard: ReactElement | null = null;
    if (props.roHistory && props.roHistory.length > 0) {
        roHistoryCard = <div id='ROHistCard'>
            <h4 className={summaryTitleCSS}>{strings.ROHistory}</h4>
            <span id='cardMsg' className={cardMsgCSS}>
                {historyMsg}
                {/* Commented out until Online Service Documents are active. */}
                {/* {strings.ROHistoryMsg} */}
                {/* <Link */}
                {/* className={css.clickHere} */}
                {/* key={0} */}
                {/* id={'clickHere'}> */}
                {/* onClick={() => onClick()}> */}
                {/* {strings.ClickHere} */}
                {/* </Link> */}
            </span>
            <hr className={css.hr} />
            <div className={css.gridRow}>
                <span>
                    {strings.Service + ' ' + strings.Description}
                </span>
                <span>
                    {strings.Date}
                </span>
                <span>
                    {strings.Repair}
                </span>
            </div>
            <hr className={css.hr} />
            <div className={css.ROHistory}>
                {roHistoryCardPanels}
            </div>
        </div>;
    }
    useEffect(() => {
        const timer = setTimeout(() => {
            if (roHistoryRef.current && props.custMode === CustMode.ViewHistory) {
                roHistoryRef.current.scrollIntoView({behavior: 'smooth'});
            }
        }, 500);

        return () => {
            clearTimeout(timer);
        };
    }, [props.custMode]);

    return (
        <div id='ROHistCardDiv' ref={roHistoryRef}>
            {roHistoryCard}
        </div>

    );
};

export default ROHistoryCard;